module.exports = __webpack_public_path__ + "media/images/countrysquared/rw-a62d94848a57d6ca6dbee03c0730c9f8.svg";